<template>
    <div class="header-container">
        <div class="left-area-container">
            <img class="logo"  :src="logo">
        </div>
        <div class="center-area-container">
            <h1 v-text="getNMRESPCONS"></h1>
        </div>
        <div class="right-area-container">
            <div class="menu" @click="changeHomeMenuVisibility"><span></span></div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'HomeHeaderComponent',
    computed: {
        ...mapGetters(['getNMRESPCONS', 'retailGeneralParams']),

        logo () {
            return this.retailGeneralParams?.TEMAESCURO
                ? require('@/assets/default/icons/no-cash-dark.svg')
                : require('@/assets/default/icons/no-cash.svg')
        }
    },
    methods: {
        ...mapActions(['changeHomeMenuVisibility'])
    }
}
</script>
<style lang="less" scoped>
.header-container {
    position: relative;
    display: grid;
    grid-template-columns: 30px calc(100% - 60px) 30px;
    height: 30px;

    img.logo {
        display: block;
        object-fit: contain;
        height: 48px;
        width: 48px;
        padding: 0;
        margin: auto;
    }
    .center-area-container {
        padding: 0 0 0 15px;
        h1 {
            height: 30px;
            font-size: 16px;
            margin: auto 0;
            padding: 0;
        }
    }
    .right-area-container {
        .menu {
            margin: 5px 0 0 auto;
            width: 24px;
            span, &:before, &:after {
                content: '';
                position: relative;
                display: block;
                background: var(--textColor);
                height: 2px;
            }
            span {
                margin: 5px 0;
            }
        }
    }
}
</style>
